import { Button, Stack, Text } from "@chakra-ui/react"
import { MdDeleteSweep } from "react-icons/md"
import SearchSelect from "components/select/SearchSelect"
import { isCompositeBroadcast } from "lib/playlist"

// "Copy from" and "Clear" above the list of a broadcast form (also the schedule of one).
// - composite: true for a composite broadcast. It can copy only from composite broadcasts, a
//   regular one only from regular broadcasts (multiplier copies are not offered: they only repeat
//   their original). The broadcast being edited is not offered either.
// - broadcasts: all broadcasts (as `useBroadcast` returns them)
// - onCopy(broadcast): the form takes the list (and resolutions) of that broadcast
// - onClear(): the form empties the list
// Nothing is saved here; the form is saved with its own button.
export default function CopyFrom({ composite, broadcasts, exceptId, onCopy, onClear, isEmpty }) {
  const sources = (broadcasts || []).filter(b => !b.sourceId && b.id !== exceptId && isCompositeBroadcast(b) === composite)

  return (
    <Stack direction={{ base: "column", md: "row" }} spacing={2} align={{ base: "stretch", md: "center" }} mb={2}>
      <Text fontSize="sm" fontWeight="medium" flexShrink={0}>Copy from</Text>
      <Stack flex="1" minW={0}>
        <SearchSelect
          placeholder={composite ? "Choose a composite broadcast..." : "Choose a regular broadcast..."}
          options={sources.map(b => ({ value: b.id, label: b.name }))}
          value=""
          onChange={id => {
            const source = sources.find(b => b.id === id)
            if (source) onCopy(source)
          }}
        />
      </Stack>
      <Button size="sm" variant="outline" colorScheme="red" borderRadius="30px" flexShrink={0}
        leftIcon={<MdDeleteSweep />} isDisabled={isEmpty} onClick={onClear}>
        Clear all
      </Button>
    </Stack>
  )
}
